import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Select, Typography } from "antd";
import { Link, useLocation } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as EmptyIcon } from "../../images/empty.svg";
import PageContainer from "../../components/PageContainer";
import BottomSheet from "../../components/BottomSheet";
import ContentSearch from "../blog/components/ContentSearch";
import { getSubscriberTicketsService } from "./support.api";
import SupportTicket from "./SupportTicket";
import AvatarPreview from "../profile/components/AvatarPreview";
import { getHoursMinutesTime, getPersianDateObj } from "../../constant/helper";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import MessageDateCategories from "../chat/message/MessageDateCategories";

const { Paragraph } = Typography;

const Support = () => {
  const { search } = useLocation();

  const containerRef = useRef();

  // eslint-disable-next-line
  const [isFetching, setIsFetching] = useInfiniteScroll(
    moreArchivesList,
    containerRef
  );
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    sort: "",
  });
  const [showTicketCategory, setShowTicketCategory] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  // eslint-disable-next-line
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [list, setList] = useState([]);

  useEffect(() => {
    setPageNumber(0);
    setList([]);
  }, [filter]);

  useEffect(() => {
    if (pageNumber === 0) {
      fetchSupportsList();
    }
    // eslint-disable-next-line
  }, [pageNumber]);

  useEffect(() => {
    setPageNumber(0);
    setList([]);
  }, [search]);

  function moreArchivesList() {
    if (showLoadMore) {
      setLoading(true);
      const searchParams = new URLSearchParams(search);
      getSubscriberTicketsService({
        pageNumber: pageNumber,
        pageSize: 1000,
        ...filter,
        ...Object.fromEntries(searchParams),
      })
        .then((r) => {
          const { content } = r.data;

          setList([...list, ...content]);

          if (r.data && r.data.last === true) {
            setShowLoadMore(false);
          } else {
            setShowLoadMore(true);
          }
          setPageNumber(pageNumber + 1);
        })
        .catch((e) => {
        })
        .finally(() => {
          setLoading(false);
          setIsFetching(false);
        });
    }
  }

  function fetchSupportsList() {
    setLoading(true);
    const searchParams = new URLSearchParams(search);

    getSubscriberTicketsService({
      pageNumber: pageNumber,
      pageSize: 1000,
      sort: filter.sort,
      sortKey: "createdDate",
      // ...filter,
      ...Object.fromEntries(searchParams),
    })
      .then((res) => {
        if (res.data.hasOwnProperty("content")) {
          const { content } = res.data;

          if (pageNumber === 0) {
            setList(content);
          } else if (content) {
            setList([...list, ...content]);
          }

          if (res.data && res.data.last === true) {
            setShowLoadMore(false);
          } else {
            setShowLoadMore(true);
          }

          setPageNumber(pageNumber + 1);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
        setIsFetching(false);
      });
  }

  function toggleTicketCategoryForm() {
    setShowTicketCategory(!showTicketCategory);
  }

  function handleChangeFilter(value) {
    setFilter({
      ...filter,
      sort: value,
      // sortKey: "createdDateMilli",
    });
  }

  return (
    <>
      <PageContainer
        classNames="support"
        loading={loading}
        headerProps={{
          link: "/menu",
          right: "",
          content: "پشتیبانی",
          className: "home-header-holder transactions-header-holder",
          children: (
            <div style={{ marginTop: 40 }}>
              <ContentSearch
                showFilterForm={false}
                allowClear={true}
                inputName="fullSearch"
                disabled={!list || (list && list.length === 0)}
              />
            </div>
          ),
          tall: true,
        }}
      >
        <div className="archive">
          <div className="archive-title center-flex">
            <div className="title">لیست پشتیبانی</div>
            <div className="lawone-selector">
              {/* Baraye Jam Kardan Bug Backend Injori neveshtam */}
              <Select
                value={filter.sort}
                placeholder={"انتخاب کنید"}
                size="small"
                onChange={handleChangeFilter}
              >
                <Select.Option value="">بدون فیلتر</Select.Option>
                <Select.Option value="ASC">صعودی</Select.Option>
                <Select.Option value="DESC">نزولی</Select.Option>
              </Select>
            </div>
          </div>
          <div className="archives-wrapper">
            {list && list.length > 0 ? (
              list.map((item, index) => {
                const {
                  id,
                  state: {
                    current: { state },
                  },
                  createdDateMilli,
                  // content,
                  categoryName,
                } = item;
                const toPersian = createdDateMilli
                  ? getPersianDateObj(createdDateMilli)
                  : null;

                return (
                  <React.Fragment>
                    <MessageDateCategories
                      className={{
                        textAlign: "center",
                        color: "#656567",
                        fontWeight: "400",
                        fontSize: "14px",
                        marginBottom: "1rem",
                      }}
                      messagesList={list}
                      index={index}
                      currentlyItem={item}
                    />

                    <Link
                      className={`archive-log ${
                        state !== "CLOSED" ? "active" : "ended"
                      }-archive-log center-flex`}
                      key={`ticket-item-${index}`}
                      to={`/support/${id}`}
                    >
                      <div className="lawyer-section center-flex">
                        <AvatarPreview
                          isSvg={false}
                          className="lawyer-avatar"
                          style={{ width: "40px" }}
                          src={3}
                        />
                        {item?.panelUnreadCount > 0 && (
                          <div className="support-unread-message">
                            {item?.panelUnreadCount}
                          </div>
                        )}
                        <div className="info">
                          <div className="">
                            <div className="title">لاوین</div>
                          </div>
                          <div className="status">
                            <span className="title">وضعیت پشتیبانی : </span>
                            <span className="text">
                              {state === "OPENED" && "در حال انجام"}
                              {state === "PROCESSING" && "در حال بررسی"}
                              {state === "CLOSED" && "بسته شده"}
                            </span>
                          </div>

                          <div className="status">
                            <div className="title">دسته بندی:</div>
                            <Paragraph ellipsis className="text">
                              {categoryName || "نا مشخص"}
                            </Paragraph>
                          </div>
                        </div>
                      </div>
                      <div className="date-info">
                        <div className="date">
                          {toPersian
                            ? `${toPersian.year}/${toPersian.month}/${toPersian.day}`
                            : ""}
                        </div>
                        <div className="time">
                          {getHoursMinutesTime(createdDateMilli, "HH:mm")}
                        </div>
                      </div>
                    </Link>
                  </React.Fragment>
                );
              })
            ) : (
              <Row>
                <Col span={24}>
                  <div className="center-flex empty">
                    <EmptyIcon className="mb-20" />
                    این صفحه خالی است
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
        <div
          className="create-fab-icon"
          onClick={() => setShowTicketCategory(true)}
        >
          <PlusOutlined />
        </div>
      </PageContainer>

      <BottomSheet
        isOpen={showTicketCategory}
        setClose={toggleTicketCategoryForm}
        classNames={"support-ticket-holder right-text"}
      >
        <SupportTicket
          opened={showTicketCategory}
          handleCreateTicket={() => {
            return false;
          }}
        />
      </BottomSheet>
    </>
  );
};

export default Support;
